<template>
    <fieldset :disabled="readonly">
        <div v-if="loaded">

            <Tabs
                v-if="id"
                :additionals="additionals"
                :form="form"
                :model="model"
                ref="Tabs"
                :readonly="readonly"
            />

            <Wizard
                v-else
                :additionals="additionals"
                :form="form"
                :model="model"
                @exit-busca="loadCidadaoData"
                @finish="save"
                @form-change="synchronizeCidadaoSearchData"
                ref="Wizard"
            />

            <Modal
                ref="Modal"
                :data="{ form, model }"
            />

            <ModalHistorico
                ref="ModalHistorico"
                :data="{ form }"
            />
        </div>
    </fieldset>
</template>

<script>
// Components.
import Tabs from './Tabs'
import Wizard from './Wizard'
import Modal from './components/impressao/Modal'
import ModalHistorico from './components/historico/Modal'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { cadastroCidadaoForm, repository, error, stringCase, object } from '@/mixins'

export default {
    components: { Tabs, Wizard, Modal, ModalHistorico },
    mixins: [ cadastroCidadaoForm, repository, error, stringCase, object ],
    props: {
        id: { type: Number },
    },
    data: () => ({
        additionals: null,
        repositories: {
            paciente: null,
        },
        form: {
            exibeConfirmacaoClassificacao: false,
            termosInvalidos: [],
            dataAtual: '',
            classificacoes: [],
            subclassificacoes: [],
            unidadesReferencia: [],
            prontuario: null,
            isUnidadeReferencia: true,
            isResponsavel: false,
            isPermissaoEndereco: null,
            isPermissaoBloquear: null,
            bloqueado: [],
            atualizacao: null,
            diasAtrasados: null,
            cadastroDomiciliarId: null,
            historico: [],
            impressoes: [],
            acompanhamentoInfantil: [],
            curso: [],
            mercadoTrabalho: [],
            orientacaoSexual: [],
            deficiencia: [],
            peso: [],
            doencasCardiacas: [],
            problemasRins: [],
            doencasRespiratorias: [],
            saidaCidadao: [],
            imovelTipo: [],
            situacaoDomicilio: [],
            domicilioTipo: [],
            situacaoRural: [],
            zonas: [],
            domicilioTipoAcesso: [],
            materialPredominante: [],
            abastecimento: [],
            tratamento: [],
            destinoLixo: [],
            formaEscoamento: [],
            higieneResidencial: [],
            animais: [],
            escalaCoelho: [],
            lazer: [],
            microareas: [],
            parentesco: [],
            residentes: [],
            residentesAnteriores: [],
            domicilioId: [],
            sistema: null,
            responsaveis: [],
        },
        model: {
            id: null,
            cadastroSimplificado: false,
            email: '',
            classificacaoId: null,
            subclassificacaoId: null,
            periodoValidade: {
                start: null,
                end: null,
            },
            prontuarioUnidade: '',
            protocoloCross: '',
            unidadeId: null,
            responsavelUsuario: null,
            responsavelInfraestruturaId: null,
            responsavelUnidadeId: null,
            responsavelEquipeId: null,
            responsavelOcupacaoId: null,
            responsavelData: null,
            bloqueado: false,
            impressoes: [],
            imovelTipoId: null,
            situacaoDomicilioId: null,
            domicilioTipoId: null,
            quantidadeComodos: null,
            situacaoRuralId: null,
            domicilioZonaId: null,
            domicilioTipoAcessoId: null,
            materialPredominanteId: null,
            abastecimentoId: null,
            tratamentoId: null,
            destinoLixoId: null,
            formaEscoamentoId: null,
            possuiAnimais: null,
            energiaEletrica: null,
            quantidadeAnimais: null,
            animal: [],
            instituicaoNome: null,
            instituicaoOutrosProfissionais: null,
            instituicaoNomeResponsavelTecnico: null,
            instituicaoCnsResponsavelTecnico: null,
            instituicaoCargoResponsavelTecnico: null,
            instituicaoTelefoneResponsavelTecnico: null,
            escalaCoelhoId: null,
            higieneResidencialId: null,
            bolsaFamilia: null,
            valeGas: null,
            bolsaEscola: null,
            lazer: [],
            bpc: null,
            foraArea: false,
            microareaId: null,
            rendaMensal: null,
            originalRendaMensal: null,
            rendaTotalFamiliar: null,
            ocupacao: null,
            cursoId: null,
            frequentaEscolaCreche: null,
            situacaoMercadoTrabalhoId: null,
            frequentaCuidadorTradicional: null,
            participaGrupoComunitario: null,
            acompanhamentoInfantil: [],
            deficiencias: [],
            planoSaude: null,
            alimentosAcabaram: false,
            comeuAlgunsAlimentos: false,
            dataAtualizacaoTria: null,
            convenioMedico: null,
            comunidadeTradicional: null,
            saidaCidadaoId: null,
            motivoSaidaData: null,
            obito: null,
            obitoEm: null,
            horaObito: null,
            obitoDeclaracao: null,
            obitoCausa: null,
            obitoCid: null,
            parentescoId: null,
            pesoId: null,
            internacao: null,
            internacaoMotivo: null,
            internacaoData: null,
            doencaCardiaca: null,
            doencaCardiacaQuais: [],
            problemasRins: null,
            problemasRinsQuais: [],
            doencaRespiratoria: null,
            doencaRespiratoriaQuais: [],
            tratamentoSaudeMental: null,
            tratamentoSaudeMentalInternacaoData: null,
            tratamentoSaudeMentalAltaData: null,
            acamado: null,
            deficiente: null,
            orientacaoSexual: null,
            orientacaoSexualId: null,
            identidadeGenero: null,
            domiciliado: null,
            plantasMedicinais: null,
            plantasMedicinaisQuais: null,
            outrasCondicoesPrimaria: null,
            outrasCondicoesSecundaria: null,
            outrasCondicoesTerciaria: null,
            possuiVeiculoProprio: false,
            possuiFinanciamento: false,
            possuiEmprestimo: false,
            recusaCadastro: false,
            dataUltimaMenstruacao: null,
            idadeGestacionalSemanas: null,
            idadeGestacionalDias: null,
            dataPossivelParto: null,
            gravidezPlanejada: null,
            gestacaoPrevia: null,
            parto: null,
            responsavel: null,
            responsavelCidadaoId: null,
            parentescoResponsavelId: null,
            comunidadeTradicionalQual: null,
            informacaoSocialRecusaCadastro: null,
            informacaoResidencialRecusaCadastro: null,
            praticasIntegrativas: null,
            veiculos: [],
            financiamentos: [],
            emprestimos: [],
            moradores: [],
        },
        loaded: false,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.readonly) {
                this.show()
            } else {
                this.create()
            }
        },
        create() {
            const request = this.id
                ? this.repositories.paciente.edit(this.id)
                : this.repositories.paciente.create()

            request
                .then(({ data }) => {
                    this.setData(data.form, data.model || null)

                    this.additionals = data.additionals

                    this.model.moradores = data.form.residentes.length

                    if (data.model) {

                        this.$emit('loaded', {additionals: this.additionals, cidadao: {
                            ...data.model.cidadao,
                            classificacaoId: data.model.classificacaoId,
                        }})
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading(this.$nextTick().then(() => this.loaded = true)))

            this.$nextTick().then(() => this.$emit('paciente', this.model))
        },
        show() {
            const request = this.repositories.paciente.show(this.id)

            request
                .then(({ data }) => {
                    this.setData(data.form, data.model || null)

                    this.additionals = data.additionals

                    this.model.moradores = data.form.residentes.length

                    if (data.model) {

                        this.$emit('loaded', {additionals: this.additionals, cidadao: {
                            ...data.model.cidadao,
                            classificacaoId: data.model.classificacaoId,
                        }})
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading(this.$nextTick().then(() => this.loaded = true)))

            this.$nextTick().then(() => this.$emit('paciente', this.model))
        },
        setData(form, model) {

            if (form.cidadao) {

                this.setCidadaoData(form.cidadao, model ? model.cidadao : null)
            }

            this.form.termosInvalidos = form.termosInvalidos
            this.form.dataAtual = form.dataAtual
            this.form.classificacoes = form.classificacoes
            this.form.subclassificacoes = form.subclassificacoes
            this.form.unidadesReferencia = form.unidadesReferencia
            this.form.prontuario = form.prontuario
            this.form.isResponsavel = form.isResponsavel
            this.form.isUnidadeReferencia = form.isUnidadeReferencia
            this.form.isPermissaoEndereco = form.isPermissaoEndereco
            this.form.isPermissaoBloquear = form.isPermissaoBloquear
            this.form.bloqueado = form.bloqueado
            this.form.atualizacao = form.atualizacao
            this.form.diasAtrasados = form.diasAtrasados
            this.form.historico = form.historico
            this.form.impressoes = form.impressoes
            this.form.acompanhamentoInfantil = form.acompanhamentoInfantil
            this.form.curso = form.curso
            this.form.mercadoTrabalho = form.mercadoTrabalho
            this.form.deficiencia = form.deficiencia
            this.form.peso = form.peso
            this.form.saidaCidadao = form.saidaCidadao
            this.form.imovelTipo = form.imovelTipo
            this.form.situacaoDomicilio = form.situacaoDomicilio
            this.form.domicilioTipo = form.domicilioTipo
            this.form.situacaoRural = form.situacaoRural
            this.form.zonas = form.zonas
            this.form.domicilioTipoAcesso = form.domicilioTipoAcesso
            this.form.materialPredominante = form.materialPredominante
            this.form.abastecimento = form.abastecimento
            this.form.tratamento = form.tratamento
            this.form.destinoLixo = form.destinoLixo
            this.form.formaEscoamento = form.formaEscoamento
            this.form.higieneResidencial = form.higieneResidencial
            this.form.animais = form.animais
            this.form.escalaCoelho = form.escalaCoelho
            this.form.lazer = form.lazer
            this.form.microareas = form.microareas
            this.form.parentesco = form.parentesco
            this.form.residentes = form.residentes ?? []
            this.form.residentesAnteriores = form.residentesAnteriores ?? []
            this.form.domicilioId = form.domicilioId
            this.form.cadastroDomiciliarId = form.cadastroDomiciliarId
            this.form.sistema = form.sistema
            this.form.responsaveis = form.responsaveis ?? []

            this.form.peso = form.peso
            this.form.doencasCardiacas = form.doencasCardiacas
            this.form.problemasRins = form.problemasRins
            this.form.doencasRespiratorias = form.doencasRespiratorias
            this.form.orientacaoSexual = form.orientacaoSexual

            if (!model) {

                this.form.exibeConfirmacaoClassificacao = true

                return
            }

            this.model.id = this.id
            this.model.email = model.email
            this.model.classificacaoId = model.classificacaoId
            this.model.alteraResponsavel = model.alteraResponsavel
            this.model.domicilioIdOld = model.domicilioIdOld
            this.model.saidaCidadaoId = model.saidaCidadaoId

            this.$nextTick(() => {

                this.model.subclassificacaoId = model.subclassificacaoId
                this.model.periodoValidade.start = model.validadeInicio
                this.model.periodoValidade.end = model.validadeFim
                this.model.prontuarioUnidade = model.prontuarioUnidade
                this.model.protocoloCross = model.protocoloCross
                this.model.unidadeId = model.unidadeId
                this.model.bloqueado = model.bloqueado ? true : false
                this.model.prontuariosUnidades = model.prontuariosUnidades
                this.model.impressoes = model.impressoes

                this.model.responsavelUsuario = model.responsavelUsuario
                this.model.responsavelUnidadeId = model.responsavelUnidadeId
                this.model.responsavelInfraestruturaId = model.responsavelInfraestruturaId
                this.model.responsavelEquipeId = model.responsavelEquipeId
                this.model.responsavelOcupacaoId = model.responsavelOcupacaoId
                this.model.responsavelData = model.responsavelData

                this.model.imovelTipoId = model.imovelTipoId
                this.model.situacaoDomicilioId = model.situacaoDomicilioId
                this.model.domicilioTipoId = model.domicilioTipoId
                this.model.quantidadeComodos = model.quantidadeComodos
                this.model.situacaoRuralId = model.situacaoRuralId
                this.model.domicilioZonaId = model.domicilioZonaId
                this.model.domicilioTipoAcessoId = model.domicilioTipoAcessoId
                this.model.materialPredominanteId = model.materialPredominanteId
                this.model.abastecimentoId = model.abastecimentoId
                this.model.tratamentoId = model.tratamentoId
                this.model.destinoLixoId = model.destinoLixoId
                this.model.formaEscoamentoId = model.formaEscoamentoId
                this.model.possuiAnimais = model.possuiAnimais
                this.model.energiaEletrica = model.energiaEletrica
                this.model.quantidadeAnimais = model.quantidadeAnimais
                this.model.animal = model.animal
                this.model.instituicaoNome = model.instituicaoNome;
                this.model.instituicaoOutrosProfissionais = model.instituicaoOutrosProfissionais;
                this.model.instituicaoNomeResponsavelTecnico = model.instituicaoNomeResponsavelTecnico;
                this.model.instituicaoCnsResponsavelTecnico = model.instituicaoCnsResponsavelTecnico;
                this.model.instituicaoCargoResponsavelTecnico = model.instituicaoCargoResponsavelTecnico;
                this.model.instituicaoTelefoneResponsavelTecnico = model.instituicaoTelefoneResponsavelTecnico;
                this.model.escalaCoelhoId = model.escalaCoelhoId
                this.model.higieneResidencialId = model.higieneResidencialId
                this.model.bolsaFamilia = model.bolsaFamilia
                this.model.valeGas = model.valeGas
                this.model.bolsaEscola = model.bolsaEscola
                this.model.lazer = model.lazer
                this.model.bpc = model.bpc
                this.model.foraArea = model.foraArea
                this.model.microareaId = model.microareaId
                this.model.rendaMensal = model.rendaMensal
                this.model.originalRendaMensal = model.rendaMensal
                this.model.rendaTotalFamiliar = model.rendaTotalFamiliar
                this.model.ocupacao = model.ocupacao
                this.model.recusaCadastro = model.recusaCadastro

                this.model.responsavel = model.responsavel;
                this.model.responsavelCidadaoId = model.responsavelCidadaoId;
                this.model.parentescoResponsavelId = model.parentescoResponsavelId;
                this.model.cursoId = model.cursoId
                this.model.frequentaEscolaCreche = model.frequentaEscolaCreche
                this.model.situacaoMercadoTrabalhoId = model.situacaoMercadoTrabalhoId
                this.model.frequentaCuidadorTradicional = model.frequentaCuidadorTradicional
                this.model.comunidadeTradicionalQual = model.comunidadeTradicionalQual;
                this.model.participaGrupoComunitario = model.participaGrupoComunitario
                this.model.acompanhamentoInfantil = model.acompanhamentoInfantil
                this.model.deficiencias = model.deficiencias
                this.model.planoSaude = model.planoSaude
                this.model.alimentosAcabaram = model.alimentosAcabaram
                this.model.comeuAlgunsAlimentos = model.comeuAlgunsAlimentos
                this.model.dataAtualizacaoTria = model.dataAtualizacaoTria
                this.model.convenioMedico = model.convenioMedico
                this.model.comunidadeTradicional = model.comunidadeTradicional
                this.model.motivoSaidaData = model.motivoSaidaData
                this.model.obito = model.obito
                this.model.obitoEm = model.obitoEm
                this.model.horaObito = model.horaObito
                this.model.obitoDeclaracao = model.obitoDeclaracao
                this.model.obitoCausa = model.obitoCausa
                this.model.obitoCid = model.obitoCid
                this.model.informacaoSocialRecusaCadastro = model.informacaoSocialRecusaCadastro;

                this.model.pesoId = model.pesoId;
                this.model.internacao = model.internacao;
                this.model.internacaoMotivo = model.internacaoMotivo;
                this.model.internacaoData = model.internacaoData;
                this.model.doencaCardiaca = model.doencaCardiaca;
                this.model.doencaCardiacaQuais = model.doencaCardiacaQuais;
                this.model.problemasRins = model.problemasRins;
                this.model.problemasRinsQuais = model.problemasRinsQuais;
                this.model.doencaRespiratoria = model.doencaRespiratoria;
                this.model.doencaRespiratoriaQuais = model.doencaRespiratoriaQuais;
                this.model.tratamentoSaudeMental = model.tratamentoSaudeMental;
                this.model.tratamentoSaudeMentalInternacaoData = model.tratamentoSaudeMentalInternacaoData;
                this.model.tratamentoSaudeMentalAltaData = model.tratamentoSaudeMentalAltaData;
                this.model.acamado = model.acamado;
                this.model.deficiente = model.deficiente;
                this.model.orientacaoSexual = model.orientacaoSexual;
                this.model.orientacaoSexualId = model.orientacaoSexualId;
                this.model.identidadeGenero = model.identidadeGenero;
                this.model.domiciliado = model.domiciliado;
                this.model.plantasMedicinais = model.plantasMedicinais;
                this.model.plantasMedicinaisQuais = model.plantasMedicinaisQuais;
                this.model.praticasIntegrativas = model.praticasIntegrativas;
                this.model.outrasCondicoesPrimaria = model.outrasCondicoesPrimaria;
                this.model.outrasCondicoesSecundaria = model.outrasCondicoesSecundaria;
                this.model.outrasCondicoesTerciaria = model.outrasCondicoesTerciaria;
                this.model.possuiVeiculoProprio = model.possuiVeiculoProprio;
                this.model.possuiFinanciamento = model.possuiFinanciamento;
                this.model.possuiEmprestimo = model.possuiEmprestimo;
                this.model.dataUltimaMenstruacao = model.dataUltimaMenstruacao;
                this.model.idadeGestacionalSemanas = model.idadeGestacionalSemanas;
                this.model.idadeGestacionalDias = model.idadeGestacionalDias;
                this.model.dataPossivelParto = model.dataPossivelParto;
                this.model.gravidezPlanejada = model.gravidezPlanejada;
                this.model.gestacaoPrevia = model.gestacaoPrevia;
                this.model.parto = model.parto;
                this.model.veiculos = model.veiculos;
                this.model.financiamentos = model.financiamentos;
                this.model.emprestimos = model.emprestimos;
                this.model.informacaoResidencialRecusaCadastro = model.informacaoResidencialRecusaCadastro;

                this.form.exibeConfirmacaoClassificacao = true
            })
        },
        save() {

            this.$refs[this.id ? 'Tabs' : 'Wizard'].validate()
                .then(valid => {

                    if (!valid) return

                    if ((!this.model.microareaId && !this.model.foraArea) || (!this.model.imovelTipoId)) {

                        this.showConfirmation(`A ficha de cadastro domiciliar não será gerada devido à ausência de
                            informações obrigatórias (Área/Microárea do domicílio e/ou Tipo do imóvel). Deseja continuar?`,
                                async () => {
                                    this.$nextTick()
                                        .then(() => this.handleSave())
                                }
                            )
                    } else {

                        this.handleSave()
                    }
                })
        },
        handleSave() {


            this.setLoading()

            const request = this.id
                ? this.repositories.paciente.update(this.id, this.prepareData())
                : this.repositories.paciente.store(this.prepareData())

            request
                .then(({ data }) => {

                    const showFinalAlerts = () => {
                        if (data.hasCadastroDomiciliar && data.hasCadastroIndividual) {

                            this.showSaveNotification()
                        } else {

                            if (!data.hasCadastroDomiciliar || !data.hasCadastroIndividual) {

                                let message = '';

                                if (!data.hasCadastroDomiciliar && !data.hasCadastroIndividual) {

                                    message = 'As fichas de cadastro domiciliar e individual não foram geradas';
                                } else if (!data.hasCadastroDomiciliar) {

                                    message = 'A ficha de cadastro domiciliar não foi gerada';
                                } else if (!data.hasCadastroIndividual) {

                                    message = 'A ficha de cadastro individual não foi gerada';
                                }

                                message += ', devido à ausência de um profissional com permissão para realizar essa ação.';

                                this.showAlert(message, 'Atenção');
                            }
                        }
                    }

                    if (!data.cidadao.cpf && !!data.cidadao.dnv && !!data.cidadao.dataNascimento
                        && moment(this.form.dataAtual, 'DD/MM/YYYY').diff(moment(data.cidadao.dataNascimento), 'days') <= 15
                    ) {

                        this.showWarningNotification(
                            'Recém-nascido cadastrado sem CPF. Regularize o CPF após emissão do registro civil.',
                            async () => {
                                this.$nextTick().then(() => showFinalAlerts())
                            }
                        )
                    }
                    else {

                        showFinalAlerts()
                    }

                    this.$emit('save', data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {

            const paciente = this.clone(this.model)

            delete paciente.id

            paciente.validadeInicio = this.model.periodoValidade.start
                ? this.others.moment(this.model.periodoValidade.start).format('YYYY-MM-DD') : null
            paciente.validadeFim = this.model.periodoValidade.end
                ? this.others.moment(this.model.periodoValidade.end).format('YYYY-MM-DD') : null
            paciente.responsavelData = this.model.responsavelData
                ? this.others.moment(this.model.responsavelData).format('YYYY-MM-DD') : null
            paciente.dataUltimaMenstruacao = this.model.dataUltimaMenstruacao
                ? this.others.moment(this.model.dataUltimaMenstruacao).format('YYYY-MM-DD') : null
            paciente.motivoSaidaData = this.model.motivoSaidaData
                ? this.others.moment(this.model.motivoSaidaData).format('YYYY-MM-DD') : null
            paciente.internacaoData = this.model.internacaoData
                ? this.others.moment(this.model.internacaoData).format('YYYY-MM-DD') : null
            paciente.tratamentoSaudeMentalInternacaoData = this.model.tratamentoSaudeMentalInternacaoData
                ? this.others.moment(this.model.tratamentoSaudeMentalInternacaoData).format('YYYY-MM-DD') : null
            paciente.tratamentoSaudeMentalAltaData = this.model.tratamentoSaudeMentalAltaData
                ? this.others.moment(this.model.tratamentoSaudeMentalAltaData).format('YYYY-MM-DD') : null

            paciente.obitoEm = this.model.obitoEm
                ? this.others.moment(this.model.obitoEm).format('DD/MM/YYYY') + ' ' + (paciente.horaObito || '00:00:00')
                : null

            paciente.comunidadeTradicionalId = this.model.comunidadeTradicionalQual ? this.model.comunidadeTradicionalQual.id : null
            paciente.ocupacaoId = this.model.ocupacao ? this.model.ocupacao.id : null
            paciente.obitoCidId = this.model.obitoCid ? this.model.obitoCid.id : null

            paciente.rendaMensal = this.parseValue(this.model.rendaMensal)
            paciente.rendaTotalFamiliar = this.parseValue(this.model.rendaTotalFamiliar)

            if(paciente.responsavel){
                paciente.parentescoResponsavelId = null
            }

            paciente.instituicaoTelefoneResponsavelTecnico =
                (this.model.instituicaoTelefoneResponsavelTecnico || '')
                    .replace(/\D/g, '')

            paciente.instituicaoCnsResponsavelTecnico =
                (this.model.instituicaoCnsResponsavelTecnico || '')
                    .replace(/\D/g, '')

            delete paciente.periodoValidade

            paciente.cidadao = this.prepareCidadaoData()
            paciente.origem = 'cadastroPaciente'

            return this.camelObjectKeysToSnakeRecursive(paciente)
        },
        parseValue($value) {
            return parseFloat($value.replace('.', '').replace(',', '.'))
        },
        print() {

            this.$refs.Modal.open()
        },
        historico() {

            this.$refs.ModalHistorico.open()
        }
    },
    created() {

        this.repositories.paciente = this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente')

        this.load()
    },
    computed: {
        readonly() {
            return this.$route.path.includes('/show/')
        },
    },
}
</script>